import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, CircleIcon } from 'lucide-react';
interface ChecklistRendererProps {
  content: string;
}
export function ChecklistRenderer({
  content
}: ChecklistRendererProps) {
  const items = content.split('\n').filter(line => line.match(/^[\s]*-\s\[([ x])\]/i)).map(line => {
    const match = line.match(/^[\s]*-\s\[([x ])\]\s*(.+)$/i);
    if (!match) return null;
    return {
      checked: match[1].toLowerCase() === 'x',
      text: match[2].trim()
    };
  }).filter(Boolean) as Array<{
    checked: boolean;
    text: string;
  }>;
  return <motion.div initial={{
    opacity: 0,
    y: 5
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2
  }} className="bg-slate-900/40 border border-slate-700 rounded-lg p-4 space-y-2" data-id="element-293">
      {items.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-294">
          {item.checked ? <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-295" /> : <CircleIcon className="w-5 h-5 text-slate-500 flex-shrink-0 mt-0.5" data-id="element-296" />}
          <span className={`text-sm ${item.checked ? 'text-slate-400 line-through' : 'text-slate-200'}`} data-id="element-297">
            {item.text}
          </span>
        </div>)}
    </motion.div>;
}